const PUB_SUB_EVENTS = {
  swiperReinit: "swiper:reInit",
  swiperAfterInit: "swiper:afterInit",
  swiperSlideChange: "swiper:slideChange",
};

const BREAKPOINTS = {
  tablet: 750,
  desktop: 990,
  desktop_medium: 1200,
  desktop_large: 1440,
};

const TAGNAMES = {
  button: "BUTTON",
  video: "VIDEO",
  deferredMedia: "DEFERRED-MEDIA",
};

window.PUB_SUB_EVENTS = PUB_SUB_EVENTS;
window.BREAKPOINTS = BREAKPOINTS;
window.TAGNAMES = TAGNAMES;
